/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { apiNurseryManagerInventoryCreateInventoryTransferPost } from '../fn/inventory/api-nursery-manager-inventory-create-inventory-transfer-post';
import { ApiNurseryManagerInventoryCreateInventoryTransferPost$Params } from '../fn/inventory/api-nursery-manager-inventory-create-inventory-transfer-post';
import { apiNurseryManagerInventoryCreateInventoryTransferPost$Plain } from '../fn/inventory/api-nursery-manager-inventory-create-inventory-transfer-post-plain';
import { ApiNurseryManagerInventoryCreateInventoryTransferPost$Plain$Params } from '../fn/inventory/api-nursery-manager-inventory-create-inventory-transfer-post-plain';
import { apiNurseryManagerInventoryGetInventoryPost } from '../fn/inventory/api-nursery-manager-inventory-get-inventory-post';
import { ApiNurseryManagerInventoryGetInventoryPost$Params } from '../fn/inventory/api-nursery-manager-inventory-get-inventory-post';
import { apiNurseryManagerInventoryGetInventoryPost$Plain } from '../fn/inventory/api-nursery-manager-inventory-get-inventory-post-plain';
import { ApiNurseryManagerInventoryGetInventoryPost$Plain$Params } from '../fn/inventory/api-nursery-manager-inventory-get-inventory-post-plain';
import { apiNurseryManagerInventoryUpdateInventoryPost } from '../fn/inventory/api-nursery-manager-inventory-update-inventory-post';
import { ApiNurseryManagerInventoryUpdateInventoryPost$Params } from '../fn/inventory/api-nursery-manager-inventory-update-inventory-post';
import { apiNurseryManagerInventoryUpdateInventoryPost$Plain } from '../fn/inventory/api-nursery-manager-inventory-update-inventory-post-plain';
import { ApiNurseryManagerInventoryUpdateInventoryPost$Plain$Params } from '../fn/inventory/api-nursery-manager-inventory-update-inventory-post-plain';
import { CreateInventoryTransferCommandResult } from '../models/create-inventory-transfer-command-result';
import { GetInventoryByItemQueryResult } from '../models/get-inventory-by-item-query-result';
import { UpdateInventoryCommandResult } from '../models/update-inventory-command-result';

@Injectable({ providedIn: 'root' })
export class InventoryService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `apiNurseryManagerInventoryUpdateInventoryPost()` */
  static readonly ApiNurseryManagerInventoryUpdateInventoryPostPath = '/api/NurseryManager/Inventory/UpdateInventory';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiNurseryManagerInventoryUpdateInventoryPost$Plain()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  apiNurseryManagerInventoryUpdateInventoryPost$Plain$Response(params?: ApiNurseryManagerInventoryUpdateInventoryPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<UpdateInventoryCommandResult>> {
    return apiNurseryManagerInventoryUpdateInventoryPost$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiNurseryManagerInventoryUpdateInventoryPost$Plain$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  apiNurseryManagerInventoryUpdateInventoryPost$Plain(params?: ApiNurseryManagerInventoryUpdateInventoryPost$Plain$Params, context?: HttpContext): Observable<UpdateInventoryCommandResult> {
    return this.apiNurseryManagerInventoryUpdateInventoryPost$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<UpdateInventoryCommandResult>): UpdateInventoryCommandResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiNurseryManagerInventoryUpdateInventoryPost()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  apiNurseryManagerInventoryUpdateInventoryPost$Response(params?: ApiNurseryManagerInventoryUpdateInventoryPost$Params, context?: HttpContext): Observable<StrictHttpResponse<UpdateInventoryCommandResult>> {
    return apiNurseryManagerInventoryUpdateInventoryPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiNurseryManagerInventoryUpdateInventoryPost$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  apiNurseryManagerInventoryUpdateInventoryPost(params?: ApiNurseryManagerInventoryUpdateInventoryPost$Params, context?: HttpContext): Observable<UpdateInventoryCommandResult> {
    return this.apiNurseryManagerInventoryUpdateInventoryPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<UpdateInventoryCommandResult>): UpdateInventoryCommandResult => r.body)
    );
  }

  /** Path part for operation `apiNurseryManagerInventoryGetInventoryPost()` */
  static readonly ApiNurseryManagerInventoryGetInventoryPostPath = '/api/NurseryManager/Inventory/GetInventory';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiNurseryManagerInventoryGetInventoryPost$Plain()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  apiNurseryManagerInventoryGetInventoryPost$Plain$Response(params?: ApiNurseryManagerInventoryGetInventoryPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<GetInventoryByItemQueryResult>> {
    return apiNurseryManagerInventoryGetInventoryPost$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiNurseryManagerInventoryGetInventoryPost$Plain$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  apiNurseryManagerInventoryGetInventoryPost$Plain(params?: ApiNurseryManagerInventoryGetInventoryPost$Plain$Params, context?: HttpContext): Observable<GetInventoryByItemQueryResult> {
    return this.apiNurseryManagerInventoryGetInventoryPost$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<GetInventoryByItemQueryResult>): GetInventoryByItemQueryResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiNurseryManagerInventoryGetInventoryPost()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  apiNurseryManagerInventoryGetInventoryPost$Response(params?: ApiNurseryManagerInventoryGetInventoryPost$Params, context?: HttpContext): Observable<StrictHttpResponse<GetInventoryByItemQueryResult>> {
    return apiNurseryManagerInventoryGetInventoryPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiNurseryManagerInventoryGetInventoryPost$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  apiNurseryManagerInventoryGetInventoryPost(params?: ApiNurseryManagerInventoryGetInventoryPost$Params, context?: HttpContext): Observable<GetInventoryByItemQueryResult> {
    return this.apiNurseryManagerInventoryGetInventoryPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<GetInventoryByItemQueryResult>): GetInventoryByItemQueryResult => r.body)
    );
  }

  /** Path part for operation `apiNurseryManagerInventoryCreateInventoryTransferPost()` */
  static readonly ApiNurseryManagerInventoryCreateInventoryTransferPostPath = '/api/NurseryManager/Inventory/CreateInventoryTransfer';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiNurseryManagerInventoryCreateInventoryTransferPost$Plain()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  apiNurseryManagerInventoryCreateInventoryTransferPost$Plain$Response(params?: ApiNurseryManagerInventoryCreateInventoryTransferPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<CreateInventoryTransferCommandResult>> {
    return apiNurseryManagerInventoryCreateInventoryTransferPost$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiNurseryManagerInventoryCreateInventoryTransferPost$Plain$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  apiNurseryManagerInventoryCreateInventoryTransferPost$Plain(params?: ApiNurseryManagerInventoryCreateInventoryTransferPost$Plain$Params, context?: HttpContext): Observable<CreateInventoryTransferCommandResult> {
    return this.apiNurseryManagerInventoryCreateInventoryTransferPost$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<CreateInventoryTransferCommandResult>): CreateInventoryTransferCommandResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiNurseryManagerInventoryCreateInventoryTransferPost()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  apiNurseryManagerInventoryCreateInventoryTransferPost$Response(params?: ApiNurseryManagerInventoryCreateInventoryTransferPost$Params, context?: HttpContext): Observable<StrictHttpResponse<CreateInventoryTransferCommandResult>> {
    return apiNurseryManagerInventoryCreateInventoryTransferPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiNurseryManagerInventoryCreateInventoryTransferPost$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  apiNurseryManagerInventoryCreateInventoryTransferPost(params?: ApiNurseryManagerInventoryCreateInventoryTransferPost$Params, context?: HttpContext): Observable<CreateInventoryTransferCommandResult> {
    return this.apiNurseryManagerInventoryCreateInventoryTransferPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<CreateInventoryTransferCommandResult>): CreateInventoryTransferCommandResult => r.body)
    );
  }

}
